import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Stakes } from '../components/Stakes';
import { ProductLoop } from '../components/ProductLoop';
import { CreatorLab } from '../components/CreatorLab';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-navy-950 text-slate-300 font-sans selection:bg-electric selection:text-white" data-id="element-182">
      <Navbar data-id="element-183" />
      <main data-id="element-184">
        <Hero data-id="element-185" />
        <Stakes data-id="element-186" />
        <ProductLoop data-id="element-187" />
        <CreatorLab data-id="element-188" />
        <FinalCTA data-id="element-189" />
      </main>
      <Footer data-id="element-190" />
    </div>;
}